import React, { Component } from "react"
import "./Index.scss"
import DataHeader from "./containers/DataHeader"
import DataTable from "./containers/DataTable"
import dataIcon from "app/styles/images/sp/data-selected.svg"
import { observer } from "mobx-react"
import Store from "app/stores/pgs/dataManage"

@observer
export default class Index extends Component {
  constructor (props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      selectedData: [] // TODO: 即将用到
    }
  }

  onSelect = (data) => {
    this.setState({
      selectedData: data
    })
  }

  render() {
    const { store } = this
    return (
      <div className="datamanage-page pgs">
        <h2 className="page-title"><img alt="" src={dataIcon} />数据管理</h2>
          <div  className="clearfix wrapper-box-first">
            <DataHeader store={store} selectedData={this.state.selectedData} />
          </div>
        <div>
          <DataTable store={store} onSelect={this.onSelect} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/data_manage/index.js